import { ColorsEnum } from "../../et3-theme/colors";

const ALPHA_HAIRLINE = "24";
const ALPHA_RING = "2E";
const ALPHA_FAINT = "0F";

export const FIELD_HEIGHT = 45;
export const FIELD_RADIUS = 12;
export const FIELD_PADDING_X = 14;
export const FIELD_GAP = 10;
export const FIELD_ICON_SIZE = 15;
export const FIELD_LABEL_HEIGHT = 24;
export const FIELD_LABEL_FONT_SIZE = 13;
export const FIELD_LABEL_LETTER_SPACING = 0.2;
export const FIELD_INPUT_FONT_SIZE = 16;
export const FIELD_BLOCK_HEIGHT_WITH_LABEL = 75;
export const FIELD_INPUT_CLASS = "et3-field-input";

export const FIELD_BORDER = `1px solid ${ColorsEnum.maastrichtBlue}${ALPHA_HAIRLINE}`;
export const FIELD_BORDER_FOCUS = `1px solid ${ColorsEnum.bondiBlue}`;
export const FIELD_SHADOW = `0 1px 2px ${ColorsEnum.maastrichtBlue}${ALPHA_FAINT}`;
export const FIELD_SHADOW_FOCUS = `0 0 0 4px ${ColorsEnum.bondiBlue}${ALPHA_RING}`;
export const FIELD_TRANSITION =
  "box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1), border-color 160ms cubic-bezier(0.4, 0, 0.2, 1)";
